import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Button from '../../../components/Button';
import MiniLoader from '../../../components/MiniLoader/MiniLoader';
import { DEFAULT_ERROR } from '../../../components/Notifications/Notification';
import { postStopMailing } from '../../../core/api';
import { EMAIL } from '../../../core/constants';
import { addNotification } from '../../../core/store/notificationsSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import './Unsubscribe.scss';

export default function Unsubscribe() {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  let history = useHistory();
  const dispatch = useAppDispatch();

  const activeCompany = useAppSelector((s) => s.user.activeCompany);

  const onClick = () => {
    setIsLoading(true);
    postStopMailing('manual-upload-needed', activeCompany?.company_id)
      .then(() => {
        setIsLoading(false);
        history.replace('/');
      })
      .catch(() => {
        dispatch(
          addNotification({
            text: t(DEFAULT_ERROR),
            type: 'error',
          })
        );
        setIsLoading(false);
      });
  };

  return (
    <div className='flex-grow-1 p-5 d-flex align-items-center align-items-lg-start justify-content-center Unsubscribe'>
      <div
        style={{
          maxWidth: i18n.language === 'en' ? 623 : 704,
        }}
        className='text-center Unsubscribe__content'
      >
        <div className='Text--30 fw-900 mb-3'>
          {t(
            'Please confirm that there is no manual turnover data for *company* for this month'
          ).replace('*company*', activeCompany?.name || '')}
        </div>
        <div
          className='mx-auto Text--20'
          style={{ maxWidth: i18n.language === 'en' ? 530 : 698 }}
        >
          <div className='mb-2'>
            {t('You will not receive any reminders in the current month.')}
          </div>
          <div className='mb-4'>
            {t(
              'If you receive any manual turnover data this month, contact your manager by phone or write to'
            )}
            &nbsp;
            <a href={`mailto:${EMAIL}`} className='Link--blue'>
              {EMAIL}
            </a>
          </div>
          <Button
            className='px-3 py-2 d-flex align-items-center mx-auto'
            onClick={onClick}
            disabled={isLoading}
          >
            {isLoading && (
              <MiniLoader className='MiniLoader--sm d-flex align-items-center justify-content-center me-2 MiniLoader--gray' />
            )}
            {t('Yes, I confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
}
